import { render, staticRenderFns } from "./IntroForm.vue?vue&type=template&id=1a938308&"
import script from "./IntroForm.vue?vue&type=script&lang=js&"
export * from "./IntroForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports